import { createStore } from 'vuex'
import {getUserInfoApi} from "@/service";
import {ElMessage} from "element-plus";
import router from "@/router";

export default createStore({
  state: {
    imgUrl:'https://upup-1308592621.cos.ap-chongqing.myqcloud.com/zah1%',
    documentHeight:500,
    openId:null,
    userInfo:{},
    projectInfo:{},
    userinfo:{},
    clist: []
  },
  getters: {
  },
  mutations: {
    setDocumentHeight(state,data){
      state.documentHeight=data
    },
    setOpenid(state,data){
      state.openId=data
    },
    setUserInfo(state,data){
      state.userinfo=data
    },
    setProjectInfo(state,data){
      state.projectInfo=data
    },
    setCllist(state,data){
      state.clist=data
    },
  },
  actions: {
    updateUserInfoStatus(context){
      getUserInfoApi().then(res => {
        if (res.data.code == 1) {
          localStorage.setItem('userInfo', JSON.stringify(res.data.data.userinfo))
          context.commit('setUserInfo',res.data.data.userinfo)
          context.commit('setProjectInfo',res.data.data)
        } else {
          localStorage.removeItem('userInfo')
          context.commit('setUserInfo',{})
          // token 失效（退出登录/换浏览器等），强制回到登录页
          if (router.currentRoute.value.path !== '/login' && router.currentRoute.value.meta.checkAuth) {
            router.replace('/login')
          }
          ElMessage({
            message: res.data.msg,
            type: 'warning',
          })
        }
      })
    }
  },
  modules: {
  }
})
